import SubMenu from 'common/navigation/components/sub-menu';
import MainMenu from 'common/navigation/containers/main-menu-container';
import Wrapper from 'common/navigation/wrapper';
import PropTypes from 'prop-types';
import React from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { withRouter } from 'utils/withRouter';
import { ticketObjectRoutes } from '../common/navigation/routes/cops-routes';
import TicketWorklistContainer from '../tickets/containers/list/ticket-worklist-container';
import { referenceTypes } from '../utils/app-configs';
import Dashboard from './dashboard/components/dashboard';
import Info from './info/containers/info-container';
import Timeline from './timeline/components/timeline';

const Customer = ({ match }) => {
  const id = match.params.customerId;
  const renderMenu = actionButtons =>
    <MainMenu id={id} type={referenceTypes.customer} actionButtons={actionButtons}>
      <SubMenu
        id={id}
        baseType={referenceTypes.customer}
        hasTickets={true}
        base={`customer/${id}`}
        extraLinks={
          [
            {
              translationKey: 'nav.subNav.TIMELINE',
              uri: `/customer/${id}/timeline`,
              absolute: true,
            },
          ]
        }
      />
    </MainMenu>;
  const ticketRoutes = ticketObjectRoutes();
  return (
    <Wrapper>
      <Routes>
        <Route
          path={'dashboard'}
          element={<Dashboard id={id} renderMenu={renderMenu} />}
        />
        <Route
          path={'info'}
          element={<Info id={id} renderMenu={renderMenu} />}
        />
        <Route
          path={'timeline/:jumpToDateOrFilter?/:filtervalue?'}
          element={<Timeline
            id={id}
            renderMenu={renderMenu}
          />
          }
        />
        {ticketRoutes?.map((r, i) => <Route
          path={`${r}/*`}
          key={i}
          element={
            <TicketWorklistContainer
              renderMenu={renderMenu}
              baseType={referenceTypes.customer}
            />
          }
        />)}
        <Route
          path='/*'
          element={<Navigate to='dashboard' replace />}
        />
      </Routes>
      <Outlet />
    </Wrapper>
  );
};

Customer.propTypes = {
  match: PropTypes.object.isRequired,
};

export default withRouter(Customer);
